import { render, staticRenderFns } from "./u-column-notice.vue?vue&type=template&id=515940d7&scoped=true&"
import script from "./u-column-notice.vue?vue&type=script&lang=js&"
export * from "./u-column-notice.vue?vue&type=script&lang=js&"
import style0 from "./u-column-notice.vue?vue&type=style&index=0&id=515940d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515940d7",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-column-notice/u-column-notice.vue"
export default component.exports